if (typeof PromoWithThumbs !== 'function') {
	class PromoWithThumbs extends HTMLElement {
		constructor() {
			super();
			this.slider = '.splide--main';
			this.nav = '.splide--nav';
			this.splide = null;
			this.splideNav = null;
			this.count = +this.dataset.count;
			this.spacing = this.dataset.spacing;

			this.prev = this.querySelector('.splide__arrow--prev');
			this.next = this.querySelector('.splide__arrow--next');

			this.has_nav = !!this.querySelector(this.nav);

			this.selectors = {
				parent: '.promo-with-thumbs__list-item-media',
			};

			this.init();
		}

		init() {
			if (typeof window.Splide !== 'undefined') {
				this.mountSlider();
			} else {
				this.loadSplide();
			}
		}

		loadSplide() {
			const checkInterval = setInterval(() => {
				if (typeof window.Splide !== 'undefined') {
					clearInterval(checkInterval);
					this.mountSlider();
				}
			}, 100);

			setTimeout(() => {
				clearInterval(checkInterval);
			}, 10000);
		}

		mountSlider() {
			const { slider, nav, count, spacing, has_nav } = this;

			this.splide = new Splide(slider, {
				type: 'fade',
				arrows: false,
				pagination: false,
				perPage: 1,
				rewind: true,
				autoplay: false,
				height: 'var(--height)',
				drag: has_nav ? false : true,
			});

			this.splide.on('active', (e) => {
				this.resetVideos();

				const currentSlide = e && e.slide ? e.slide : null;

				if (currentSlide) {
					const video = currentSlide.querySelector('video');

					if (video) {
						video.play();
					}
				}
			});

			if (has_nav) {
				this.splideNav = new Splide(nav, {
					type: 'slide',
					gap: `${spacing}px`,
					updateOnMove: true,
					fixedWidth: 138,
					pagination: false,
					isNavigation: true,
					perPage: count,
					perMove: 1,
					rewind: true,
					autoplay: false,
					arrows: false,
					pagination: false,
					padding: '2em',
					breakpoints: {
						1024: {
							perPage: 5,
						},
						768: {
							fixedWidth: 100,
							gap: `${spacing / 2}px`,
							perPage: 3,
							padding: '1.5em',
						},
					},
				});

				this.splide.sync(this.splideNav);
			}

			this.splide.mount();

			if (has_nav) {
				this.splideNav.mount();
				this.mountArrows();
			}
		}

		mountArrows() {
			const { splide, prev, next } = this;

			prev.addEventListener('click', (e) => {
				splide.go('-1');
			});

			next.addEventListener('click', (e) => {
				splide.go('+1');
			});
		}

		resetVideos() {
			this.querySelectorAll('video').forEach((video) => {
				video.pause();
				video.currentTime = 0;
			});
		}
	}

	if (!customElements.get('promo-with-thumbs')) {
		customElements.define('promo-with-thumbs', PromoWithThumbs);
	}
}
